// Phase 2.11 — Canonical Owner options for assessment findings.
// Used by FindingsTab / TelecomFindingsSection editors. Stored on
// assessment_findings.owners (text[]).
export const FINDING_OWNER_OPTIONS = [
  "Network Engineering",
  "Security Engineering",
  "SOC Team",
  "App Developers",
  "Application Security",
  "IT Operations",
  "IT Asset Management",
  "Vendor Management",
  "Risk Management",
  "Compliance",
  "Legal",
  "Finance",
  "Procurement",
  "Infrastructure Team",
  "Cloud Engineering",
  "Data Center Operations",
  "CISO",
  "Executive Sponsor",
  "Other",
] as const;

export type FindingOwner = (typeof FINDING_OWNER_OPTIONS)[number];
